import * as types from "./actionTypes";

export const getAll = (data, pageNumber = null) => {
  return {
    type: types.API_CALL_ACTIVITY_REQUEST,
    data,
    pageNumber
  };
};

export const getAllSuccess = data => {
  return {
    type: types.PUT_ACTIVITY,
    payLoad: { data, loading: false }
  };
};
export const getAllFailure = data => {
  return {
    type: types.API_CALL_ACTIVITY_FAILURE,
    payLoad: { data, loading: false }
  };
};

export const remove = (data, { goBack = false }) => {
  return {
    type: types.API_REMOVE_ACTIVITY_REQUEST,
    payLoad: { data, goBack }
  };
};

export const removeSuccess = data => {
  return {
    type: types.API_REMOVE_ACTIVITY_SUCCESS,
    payLoad: { data, loading: false }
  };
};

export const removeFailure = data => {
  return {
    type: types.STORE_ACTIVITY_FAILURE,
    payLoad: { data, loading: false }
  };
};

export const getDaily = data => {
  return {
    type: types.GET_DAILY_ACTIVITY_REQUEST,
    data
  };
};

export const getDailySuccess = data => {
  return {
    type: types.GET_DAILY_ACTIVITY_SUCCESS,
    payLoad: { data, loading: false }
  };
};
export const getDailyFailure = data => {
  return {
    type: types.GET_DAILY_ACTIVITY_FAILURE,
    payLoad: { data, loading: false }
  };
};

export const getMonthly = data => {
  return {
    type: types.GET_MONTHLY_ACTIVITY_REQUEST,
    data
  };
};

export const getMonthlySuccess = data => {
  return {
    type: types.GET_MONTHLY_ACTIVITY_SUCCESS,
    payLoad: { data, loading: false }
  };
};
export const getMonthlyFailure = data => {
  return {
    type: types.GET_MONTHLY_ACTIVITY_FAILURE,
    payLoad: { data, loading: false }
  };
};

export const store = (data, { getActivityListData = null, getActivity = null }) => {
  return {
    type: types.STORE_ACTIVITY_REQUEST,
    data: data,
    getActivityListData: getActivityListData,
    getActivity: getActivity
  };
};

export const storeSuccess = (data, deletedItemId) => {
  return {
    type: types.STORE_ACTIVITY_SUCCESS,
    storeData: data,
    deletedItemId: deletedItemId
  };
};
export const storeFailure = (data, deletedItemId) => {
  return {
    type: types.STORE_ACTIVITY_FAILURE,
    storeData: data,
    deletedItemId: deletedItemId
  };
};

export const getRequest = id => {
  return {
    type: types.GET_ACTIVITY_REQUEST,
    id
  };
};

export const getSuccess = data => {
  return {
    type: types.GET_ACTIVITY_SUCCESS,
    payLoad: data
  };
};
export const getFailure = () => {
  return {
    type: types.GET_ACTIVITY_FAILURE
  };
};
